module.exports = __webpack_public_path__ + "static/realtime_virtual-5303512475e24c39c5e1a889a8fd5e22.png";